export default {"src":"/_next/static/media/maintain.15bad497.svg","height":656,"width":1200,"blurWidth":0,"blurHeight":0};